import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import Profile from "./modules/Profile";
import Portfolio from "./modules/Portfolio";
import Tag from "./modules/Tag";
import Collection from "./modules/Collection.store"
import Categoty from "./modules/Categoty";
import Common from "./modules/Common";
import Auth from "./modules/Auth.store";
import Page from "./modules/Page.Store.js"
import contact from "./modules/Contact.Store"


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    profile: Profile,
    portfolio: Portfolio,
    tag: Tag,
    Collection: Collection,
    Categoty: Categoty,
    Common: Common,
    auth: Auth,
    Page: Page,
    contact: contact,
  },
  plugins: [createPersistedState()]
})
